<script>
import { useAuthStore } from "@/stores/authStore";

export default {
    methods: {
        can(permiso) {
            const authStore = useAuthStore();
            const user = authStore.user;

            // TESTEO: Si ves esto en consola, sabrás qué está pasando
            // console.log(`Revisando permiso: ${permiso} para usuario:`, user?.name, "Roles:", user?.roles);

            if (!user || !user.roles) {
                return false;
            }

            // Administrador siempre tiene acceso
            if (user.roles.includes('Administrador')) return true;

            const mapeo = {
                'menu-director': ['Director'],
                'menu-secretaria': ['Secretaria'],
                'menu-docente': ['Docente'],
                'menu-estudiante': ['Estudiante'],
                'menu-tutor-est': ['Tutor de estudiante'],
                'menu-tutor-par': ['Tutor de Paralelo']
            };

            const rolesPermitidos = mapeo[permiso];
            if (!rolesPermitidos) return false;

            // Verificamos si hay coincidencia
            const tieneAcceso = user.roles.some(rol => rolesPermitidos.includes(rol));
            
            

            return tieneAcceso;
        },
        getUser() {
            const authStore = useAuthStore();
            return authStore.user;
        }
    }
};
</script>